<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير الموظفين"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[name, desc, `تقرير قوائم الموظفين`]"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: [
    "name",
    "desc",
    "month",
    "departmentId",
    "departmentClassificationsId",
    "jobType",
  ],
  data() {
    return {
      json_fields: {
        "ر.ت": "num",
        الإسم: "fullName",
        "رقم الموظف": "jobNumber",
        "الرقم الوطنى": "nationalNumber",
        الادارة: "departmentName",
        "الصفة الوظيفية": "jobTitle",
        "المؤهل العلمي": "scientificDegreeName",
        الدرجة: "currentGrade",
        العلاوة: "currentBonus",
      },
    };
  },
  methods: {
    async fetchData() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);

      let result = await axios.get(
        `${env.HR()}/api/hr/employees/filter?&DepartmentClassificationsId=${
          this.departmentClassificationsId
        }&DepartmentId=${this.departmentId}&JobType=${this.jobType}&PageSize=500
        `,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      result.data.data.results.forEach((x, i) => {
        x.num = i + 1;
      });

      return result.data.data.results;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
    convert_excel(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return `${d.getFullYear()} - ${d.getMonth() + 1} - ${d.getDate()}`;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped></style>
